import { ref, type MaybeRefOrGetter, provide } from 'vue';
import {
  checkValuesAlreadyProvided,
  CreateInjectionKeysRecord,
  type InjectionValuesRecord,
  type InjectionKeysRecord,
  injectRequiredWithSelf
} from "@mcwd/util-vue";
import { type Nil } from '@mcwd/typescript-type-guards';
import { useFormLogger } from "./use-form-logger.js";

type UseEclipseHtmlFormElementInjectionValues = InjectionValuesRecord<{
  EclipseHtmlFormElement: MaybeRefOrGetter<HTMLFormElement | Nil>;
  setEclipseHtmlFormElement: (formEl: HTMLFormElement) => void;
}>;

type UseEclipseHtmlFormElementInjectionKeys = InjectionKeysRecord<UseEclipseHtmlFormElementInjectionValues>;

const UseEclipseHtmlFormElementInjectionKeys = CreateInjectionKeysRecord<UseEclipseHtmlFormElementInjectionKeys>({
  EclipseHtmlFormElement: "EclipseHtmlFormElement",
  setEclipseHtmlFormElement: "setEclipseHtmlFormElement"
});


export function initEclipseHtmlFormElement()
{
  if (checkValuesAlreadyProvided(UseEclipseHtmlFormElementInjectionKeys)) {
    return;
  }
  const EclipseHtmlFormElement = ref<HTMLFormElement | Nil>(null);
  const setEclipseHtmlFormElement = (formEl: HTMLFormElement) => {
    EclipseHtmlFormElement.value = formEl;
  };
  provide(UseEclipseHtmlFormElementInjectionKeys.EclipseHtmlFormElement, () => EclipseHtmlFormElement.value);
  provide(UseEclipseHtmlFormElementInjectionKeys.setEclipseHtmlFormElement, setEclipseHtmlFormElement);
}


export const useEclipseHtmlFormElement = ({ callerLabel }: { callerLabel?: string | undefined } = {}) => {
  const { logger } = useFormLogger();
  try {
    const EclipseHtmlFormElement = injectRequiredWithSelf(UseEclipseHtmlFormElementInjectionKeys.EclipseHtmlFormElement);
    const setEclipseHtmlFormElement = injectRequiredWithSelf(UseEclipseHtmlFormElementInjectionKeys.setEclipseHtmlFormElement);
    return {EclipseHtmlFormElement, setEclipseHtmlFormElement};
  }
  catch (err) {
    logger.error(`InjectionError from ${callerLabel ?? 'unknown'}`);
    throw err;
  }
};